<template>
  <div ref="container" class="turnstile-widget"></div>
</template>

<script>
const SCRIPT_ID = 'cf-turnstile-script'
const SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

export default {
  name: 'TurnstileWidget',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'light'
    }
  },
  data() {
    return {
      widgetId: null
    }
  },
  mounted() {
    this.loadAndRender()
  },
  beforeDestroy() {
    this.removeWidget()
  },
  methods: {
    loadAndRender() {
      if (!this.sitekey) {
        this.$emit('error')
        return
      }
      this.ensureScript()
        .then(this.renderWidget)
        .catch(() => this.$emit('error'))
    },
    ensureScript() {
      if (window.turnstile) {
        return Promise.resolve()
      }
      return new Promise((resolve, reject) => {
        const existing = document.getElementById(SCRIPT_ID)
        if (existing) {
          if (window.turnstile) {
            resolve()
            return
          }
          existing.addEventListener('load', () => resolve())
          existing.addEventListener('error', () => reject(new Error('Turnstile script failed')))
          return
        }
        const script = document.createElement('script')
        script.id = SCRIPT_ID
        script.src = SCRIPT_SRC
        script.async = true
        script.defer = true
        script.onload = () => resolve()
        script.onerror = () => reject(new Error('Turnstile script failed'))
        document.head.appendChild(script)
      })
    },
    renderWidget() {
      if (!this.$refs.container || !window.turnstile) {
        return
      }
      this.widgetId = window.turnstile.render(this.$refs.container, {
        sitekey: this.sitekey,
        theme: this.theme,
        language: 'es',
        appearance: 'always',
        callback: token => this.$emit('verify', token),
        'expired-callback': () => this.$emit('expire'),
        'error-callback': () => this.$emit('error'),
        'timeout-callback': () => this.$emit('expire')
      })
    },
    reset() {
      if (window.turnstile && this.widgetId != null) {
        window.turnstile.reset(this.widgetId)
      }
      this.$emit('expire')
    },
    removeWidget() {
      if (window.turnstile && this.widgetId != null) {
        window.turnstile.remove(this.widgetId)
        this.widgetId = null
      }
    }
  }
}
</script>

<style scoped>
.turnstile-widget {
  min-height: 65px;
}
</style>
